import { DTC_API_BASE_URL } from '../config';

export const DTCAPIRoutes = {
  requestAudience: () => `${DTC_API_BASE_URL}/request`,
  audienceQualityScore: () => `${DTC_API_BASE_URL}/deciles`,
  updateStatus: () => `${DTC_API_BASE_URL}/status`,
  quotaInfo: () => `${DTC_API_BASE_URL}/quota`,
  publishAudience: () => `${DTC_API_BASE_URL}/publish`,
  selectAudience: () => `${DTC_API_BASE_URL}/select`,
};
